export default __webpack_public_path__ + "media/images/dashboard_icons/link-ed8d7d0fade7344d0fc059fcd3dca427.svg";